var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuggageGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.83203,
    y: 6.10156,
    width: 13.6667,
    height: 14.6444,
    rx: 0.5,
    stroke: "#D4BC87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73047 5.60065V2.33398C9.73047 1.7817 10.1782 1.33398 10.7305 1.33398H14.5971C15.1494 1.33398 15.5971 1.7817 15.5971 2.33398V5.60065",
    stroke: "#D4BC87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26589 21.2457C8.26589 21.4325 8.30382 21.6175 8.37753 21.79C8.45124 21.9626 8.55927 22.1193 8.69546 22.2514C8.83165 22.3835 8.99334 22.4882 9.17128 22.5597C9.34923 22.6312 9.53995 22.668 9.73255 22.668C9.92516 22.668 10.1159 22.6312 10.2938 22.5597C10.4718 22.4882 10.6334 22.3835 10.7696 22.2514C10.9058 22.1193 11.0139 21.9626 11.0876 21.79C11.1613 21.6175 11.1992 21.4325 11.1992 21.2457L9.73255 21.2457H8.26589Z",
    fill: "#D4BC87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1331 21.2457C14.1331 21.4325 14.171 21.6175 14.2447 21.79C14.3184 21.9626 14.4265 22.1193 14.5626 22.2514C14.6988 22.3835 14.8605 22.4882 15.0385 22.5597C15.2164 22.6312 15.4071 22.668 15.5997 22.668C15.7923 22.668 15.9831 22.6312 16.161 22.5597C16.339 22.4882 16.5006 22.3835 16.6368 22.2514C16.773 22.1193 16.8811 21.9626 16.9548 21.79C17.0285 21.6175 17.0664 21.4325 17.0664 21.2457L15.5997 21.2457H14.1331Z",
    fill: "#D4BC87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1055 9.86719C10.1055 9.66008 9.93758 9.49219 9.73047 9.49219C9.52336 9.49219 9.35547 9.66008 9.35547 9.86719H10.1055ZM9.35547 16.9783C9.35547 17.1854 9.52336 17.3533 9.73047 17.3533C9.93758 17.3533 10.1055 17.1854 10.1055 16.9783H9.35547ZM9.35547 9.86719V16.9783H10.1055V9.86719H9.35547Z",
    fill: "#D4BC87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0391 9.86719C13.0391 9.66008 12.8712 9.49219 12.6641 9.49219C12.457 9.49219 12.2891 9.66008 12.2891 9.86719H13.0391ZM12.2891 16.9783C12.2891 17.1854 12.457 17.3533 12.6641 17.3533C12.8712 17.3533 13.0391 17.1854 13.0391 16.9783H12.2891ZM12.2891 9.86719V16.9783H13.0391V9.86719H12.2891Z",
    fill: "#D4BC87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 9.86719C15.9727 9.66008 15.8048 9.49219 15.5977 9.49219C15.3905 9.49219 15.2227 9.66008 15.2227 9.86719H15.9727ZM15.2227 16.9783C15.2227 17.1854 15.3905 17.3533 15.5977 17.3533C15.8048 17.3533 15.9727 17.1854 15.9727 16.9783H15.2227ZM15.2227 9.86719V16.9783H15.9727V9.86719H15.2227Z",
    fill: "#D4BC87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageGold);
export default __webpack_public_path__ + "static/media/luggage-gold.30ede26ca8f692ad134b8b6af5ce24c0.svg";
export { ForwardRef as ReactComponent };